const scrollFns = [];

function addScrollListener(fn) {
  scrollFns.push(fn);
}

function handleScroll() {
  scrollFns.forEach(fn => fn());
}

window.addEventListener('scroll', handleScroll);

export {
  addScrollListener,
};
